






















































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
/* component */
import Toast from '@/app/components/Common/Toast.vue'
/* api */
import MypagePasswordApi from '@/app/model/api/mypagePasswordApi'
/* module */
import Validator from '@/app/module/validator'
import { routerPath } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    Toast
  }
})
export default class extends Vue {
  private showEditModal: boolean = false
  private currentPassword: string = ''
  private newPassword: string = ''
  private confirmNewPassword: string = ''
  private errorMessages: {[key: string]: string} = {}
  private showCompleteAlert: boolean = false
  private showErrorAlert: boolean = false
  private alertMessage: string = ''

  @Prop() private userData!: any

  private async doPasswordEdit () {
    if (!this.isPasswordEdit()) {
      return
    }

    /* API側修正完了後に対応 */
    const bodyData: any = {
      'password': this.currentPassword,
      'new_password': this.newPassword
    }

    const result = await MypagePasswordApi.doMypagePasswordResetting(bodyData)
    if (result.isOk()) {
      /* モーダル閉じる前に入力値をクリア */
      this.currentPassword = ''
      this.newPassword = ''
      this.confirmNewPassword = ''

      this.showEditModal = false
      this.showCompleteAlert = true
    } else if (result.checkTimeoutErrorStatus()) {
      this.$store.commit('routeState/setTimeoutErrorFlag', true)
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkErrorStatus()) {
      this.$store.commit('routeState/setErrorFlag', true)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkNotFoundStatus()) {
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkStatus()) {
      CommonClass.doLogout()
    } else {
      this.closeEditModal()
      this.alertMessage = result.getPayload().message
      this.showErrorAlert = true
    }
  }

  private isPasswordEdit () {
    let currentPasswordFlag = Validator.validateInputPassword('CurrentPasswordMessage', this.currentPassword)
    let newPasswordFlag = Validator.validateInputPassword('NewPasswordErrorMessage', this.newPassword)
    let confirmNewPasswordFlag = Validator.validateInputConfirmPassword('confirmPasswordErrorMessage', this.confirmNewPassword)

    this.errorMessages = Validator.getErrorMessage()

    /* 新しいパスワード入力チェック */
    if (newPasswordFlag && confirmNewPasswordFlag) {
      if (this.newPassword === this.confirmNewPassword) {
        newPasswordFlag = true
        confirmNewPasswordFlag = true
      } else {
        this.errorMessages.confirmPasswordErrorMessage = '入力内容が「新しいパスワード」と一致しません。'
        newPasswordFlag = false
        confirmNewPasswordFlag = false
      }
    }

    return currentPasswordFlag && newPasswordFlag && confirmNewPasswordFlag
  }

  private closeEditModal () {
    /* モーダル閉じる前に入力値をクリア */
    this.currentPassword = ''
    this.newPassword = ''
    this.confirmNewPassword = ''

    this.showEditModal = false
  }

  private closeAlert () {
    this.showErrorAlert = false
    this.showCompleteAlert = false
  }
}
